import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=65d4ffa7"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"
import style0 from "./ErrorAlert.vue?vue&type=style&index=0&id=65d4ffa7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports